import React from 'react';
import Header from '../Header';
import styles from '../../assets/styles/components/MainLayout.module.scss';
import { useRedirectIfNoUser } from "../../hooks/useRedirectIfNoUser";
import { useUser } from "../../contexts/UserContext";

interface MainLayoutProps {
  children: React.ReactNode;
  title?: string;
  fullBleed?: boolean;
  headerRight?: React.ReactNode;
  headerContent?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  headerRight,
  headerContent,
  title = "",
  fullBleed = false
}) => {
  const { user, loading } = useUser();
  useRedirectIfNoUser({ user, loading });
  const mainWrapClassName = fullBleed
    ? `${styles.mainWrap} ${styles.mainWrapFullBleed}`
    : styles.mainWrap;

  return (
    <div className={styles.mainLayoutContainer}>
      <Header />
      <div className={styles.content}>
        <header className={styles.header}>
          <div className={styles.headerleft}>
            <h1 className={styles.pageTitle}>{title}</h1>
            {headerContent}
          </div>
          <div className={styles.headerRight}>
            {headerRight}
          </div>
        </header>
        <main className={mainWrapClassName}>{children}</main>
      </div>
    </div>
  );
};

export default MainLayout;
